import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';
import { TasksService, Leader } from '../services/tasks.service';
import { MatTableDataSource, MatSort } from '@angular/material';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit {

  public selectedTime: string = "month";
  public activeTime: string = "month";
  displayedColumns = ['name', 'wins', 'losses', 'win_percentage'];
  public leaderboardData: any = [];

  @ViewChild(MatSort) sort: MatSort;
  
  constructor(private AuthenticationService: AuthenticationService, private TasksService: TasksService) { }

  ngOnInit() {
    this.getMonthlyLeaderboard();
  }

  updateLeaderboardData() {
    if (this.activeTime !== this.selectedTime) {
      this.leaderboardData = [];
      if (this.selectedTime === 'month') this.getMonthlyLeaderboard();
      if (this.selectedTime === 'year') this.getYearlyUserLeaderboard();
      if (this.selectedTime === 'all') this.getAllTimeUserLeaderboard();
    }
  }

  getMonthlyLeaderboard() {
    this.activeTime = 'month';
    this.TasksService.getMonthlyUserLeaderboard(this.AuthenticationService.id()).subscribe(
      (data: Leader[]) => { 
        this.leaderboardData =  new MatTableDataSource(data);
        this.leaderboardData.sort = this.sort;
      },
      err => console.error(err)
    );
  }

  getYearlyUserLeaderboard() {
    this.activeTime = 'year';
    this.TasksService.getYearlyUserLeaderboard(this.AuthenticationService.id()).subscribe(
      (data: Leader[]) => { 
        this.leaderboardData =  new MatTableDataSource(data);
        this.leaderboardData.sort = this.sort;
      },
      err => console.error(err)
    );
  }

  getAllTimeUserLeaderboard() {
    this.activeTime = 'all';
    this.TasksService.getAllTimeUserLeaderboard(this.AuthenticationService.id()).subscribe(
      (data: Leader[]) => { 
        this.leaderboardData =  new MatTableDataSource(data);
        this.leaderboardData.sort = this.sort;
      },
      err => console.error(err)
    );
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/leaderboard/leaderboard.component.ts